export var DATE_PICKER_HEAD_SLOT_CLASS_PREFIX = 'DatePickerHeadSlot';